import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import cn from 'classnames';

import styles from './Table.module.scss';

import {ReactComponent as Expander} from './assets/expander.svg';

export const Table = ({
  columns,
  data,
  accordion,
  defaultPageSize,
  pageSize,
  height,
  loading,
  minRows,
  className,
}) => (
  <ReactTable
    className={cn(styles.wrap, className)}
    minRows={minRows}
    pageSize={pageSize}
    loading={loading}
    showPagination={false}
    showPageSizeOptions={false}
    data={data}
    ExpanderComponent={() => <Expander className={styles.expander} />}
    columns={columns}
    defaultPageSize={defaultPageSize}
    SubComponent={accordion}
    style={{height}}
    footer={null}
  />
);

Table.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object),
  data: PropTypes.arrayOf(PropTypes.object),
  accordion: PropTypes.func,
  defaultPageSize: PropTypes.number,
  pageSize: PropTypes.number,
  height: PropTypes.number,
  loading: PropTypes.bool,
  minRows: PropTypes.number,
  className: PropTypes.string,
};

Table.defaultProps = {
  columns: [],
  data: [],
  accordion: null,
  defaultPageSize: 10,
  pageSize: 10,
  height: null,
  loading: false,
  minRows: 3,
  className: null,
};
